import { render, staticRenderFns } from "./TableFooterResults.vue?vue&type=template&id=428d1db6&"
import script from "./TableFooterResults.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableFooterResults.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports